import React from 'react';

export default function Close({ width = '17', height = '17', viewBox = `0 0 ${width} ${height}` }) {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8.49951" r="8.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.20156 5.06369C5.89318 4.7553 5.39319 4.7553 5.0848 5.06369C4.77642 5.37207 4.77642 5.87206 5.0848 6.18044L7.43952 8.53516L5.13361 11.0058C4.83604 11.3246 4.85327 11.8243 5.1721 12.1219C5.49093 12.4194 5.99062 12.4022 6.28819 12.0834L8.55694 9.65258L11.075 12.1707C11.3834 12.4791 11.8834 12.4791 12.1918 12.1707C12.5002 11.8623 12.5002 11.3623 12.1918 11.0539L9.63519 8.49731L11.8159 6.16088C12.1134 5.84205 12.0962 5.34236 11.7774 5.04479C11.4585 4.74721 10.9588 4.76444 10.6613 5.08327L8.51777 7.37989L6.20156 5.06369Z"
        fill="#121212"
      />
    </svg>
  );
}
